import React, { useMemo } from 'react';
import { Form } from 'react-bootstrap-5';
import classNames from 'classnames';
import { v4 as uuid } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { profilePremiumSignupUrl } from 'bundles/connect/helpers/prospect_api';
import { faLock } from '@fortawesome/pro-regular-svg-icons';

type ToggleProps = {
  bordered?: boolean;
  checked: boolean;
  disabled?: boolean;
  label: React.ReactNode;
  onClick: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
export default function Toggle({
  bordered = false,
  checked,
  disabled = false,
  label,
  onClick
}: ToggleProps) {
  const id = useMemo(() => uuid(), []);

  return (
    <label
      className={
        classNames(
          'd-flex align-items-center gap-2 justify-content-between',
          {
            'active': checked,
            'flex-row-reverse form-control as-button bg-white': bordered,
          }
        )
      }
      htmlFor={`toggle-${id}`}
      style={{ width: '100%' }}
    >
      <div className="d-flex align-items-center gap-1">
        <Form.Check
          checked={checked}
          className="m-0 p-0"
          disabled={disabled}
          id={`toggle-${id}`}
          type="switch"
          onChange={onClick}
        />
        {disabled && (
          <a
            className="fw-bolder text-dark"
            href={profilePremiumSignupUrl}
            rel="noopener noreferrer"
            target="_blank"
          >
            <div className={classNames({ 'fw-bolder': !bordered })}>
              <FontAwesomeIcon className="text-secondary me-2 ms-1" icon={faLock} />
              {label}
            </div>
          </a>
        )}
        {!disabled && (
          <div className={classNames({ 'fw-bolder': !bordered })}>
            {label}
          </div>
        )}
      </div>
    </label>
  );
}
